/*
 * Cart note auto-save
 * -----------------------------------------------------------------------------
 * The theme's cart note (<cart-note> in snippets/cart-note.liquid) only persists
 * to the cart when the shopper clicks the "Save" button. This makes the note
 * save on its own — after a short typing pause, on blur, and flushed on the way
 * to checkout / page unload — so whatever is typed goes through even if Save is
 * never clicked. The Save button is left untouched and keeps working.
 *
 * Writes go to /cart/update.js with { note }, exactly like the theme's button.
 */
(function () {
  var routes = (window.Shopify && window.Shopify.routes) || {};
  var UPDATE_URL = (routes.cart_update_url || '/cart/update') + '.js';

  var IDLE_MS = 500;      // save this long after the last keystroke
  var timer = null;
  var lastSaved = null;   // avoid redundant writes

  function isNote(el) {
    return el && el.tagName === 'TEXTAREA' && el.name === 'note' &&
      el.closest && el.closest('cart-note');
  }

  function currentNoteEl() {
    return document.querySelector('cart-note textarea[name="note"]');
  }

  // Briefly reflect the "saved" state on the sibling Save button, matching what
  // the theme shows when the button is clicked.
  function flashSaved(noteEl) {
    if (!noteEl) return;
    var host = noteEl.closest('cart-note');
    var btn = host && host.querySelector('button[data-text-note-saved]');
    if (!btn) return;
    var saved = btn.getAttribute('data-text-note-saved');
    var normal = btn.getAttribute('data-text-btn-save') || btn.textContent;
    if (saved) {
      btn.textContent = saved;
      clearTimeout(btn._noteFlash);
      btn._noteFlash = setTimeout(function () { btn.textContent = normal; }, 2000);
    }
  }

  function save(note, noteEl, useBeacon) {
    if (note == null || note === lastSaved) return;
    lastSaved = note;
    var body = JSON.stringify({ note: note });

    // On the way out of the page, sendBeacon guarantees the write completes.
    if (useBeacon && navigator.sendBeacon) {
      try {
        navigator.sendBeacon(UPDATE_URL, new Blob([body], { type: 'application/json' }));
        return;
      } catch (e) { /* fall through to fetch */ }
    }

    fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body,
      keepalive: true
    }).then(function () { flashSaved(noteEl); }).catch(function () {});
  }

  // Debounced save while typing.
  document.addEventListener('input', function (e) {
    if (!isNote(e.target)) return;
    var el = e.target;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; save(el.value, el); }, IDLE_MS);
  });

  // Immediate save when the field loses focus.
  document.addEventListener('blur', function (e) {
    if (!isNote(e.target)) return;
    if (timer) { clearTimeout(timer); timer = null; }
    save(e.target.value, e.target);
  }, true);

  // Flush the latest note when leaving the page or heading to checkout, so an
  // un-blurred edit still makes it into the order.
  function flush() {
    var el = currentNoteEl();
    if (el) save(el.value, el, true);
  }
  window.addEventListener('pagehide', flush);
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest(
      '[name="checkout"], .btn-checkout, .cart-checkout, [href*="/checkout"]'
    );
    if (c) flush();
  }, true);
})();
